var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var API_BASE_URL = '/api';
var STATUS_MESSAGES = {
    403: "You don't have permission to do this.",
    404: 'The requested item was not found.',
    413: 'The file is too large.',
    429: 'Too many requests. Please wait a moment and try again.',
};
var ApiService = /** @class */ (function () {
    function ApiService() {
    }
    // F-16: the JWT lives in an HttpOnly cookie sent automatically with
    // credentials:'include'. JS no longer reads or attaches the token, so an
    // XSS payload cannot exfiltrate it.
    ApiService.prototype.getAuthHeaders = function () {
        return {
            'Content-Type': 'application/json',
        };
    };
    // Reads the body only when there is one: 403s and some errors come back
    // empty, and response.json() on an empty body throws "Unexpected end of JSON input".
    ApiService.prototype.parseBody = function (response) {
        return __awaiter(this, void 0, Promise, function () {
            var text;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, response.text()];
                    case 1:
                        text = _a.sent();
                        if (!text) {
                            return [2 /*return*/, undefined];
                        }
                        try {
                            return [2 /*return*/, JSON.parse(text)];
                        }
                        catch (_b) {
                            return [2 /*return*/, text];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ApiService.prototype.request = function (endpoint, init) {
        return __awaiter(this, void 0, Promise, function () {
            var response, data, serverMessage, errorMessage, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch("".concat(API_BASE_URL).concat(endpoint), __assign(__assign({}, init), { credentials: 'include' }))];
                    case 1:
                        response = _a.sent();
                        if (response.status === 401) {
                            localStorage.removeItem('token');
                            window.location.href = '/login';
                            throw new Error('Unauthorized');
                        }
                        return [4 /*yield*/, this.parseBody(response)];
                    case 2:
                        data = _a.sent();
                        if (response.ok) {
                            return [2 /*return*/, {
                                    success: true,
                                    data: data !== null && data !== void 0 ? data : { message: 'Success' },
                                    message: 'Success',
                                }];
                        }
                        serverMessage = data && typeof data === 'object' ? data.message || data.error : undefined;
                        errorMessage = STATUS_MESSAGES[response.status] ||
                            serverMessage ||
                            (response.status >= 500 ? 'Server error. Please try again.' : 'Request failed');
                        return [2 /*return*/, {
                                success: false,
                                message: errorMessage,
                                error: errorMessage,
                            }];
                    case 3:
                        error_1 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                error: error_1 instanceof Error ? error_1.message : 'Network error',
                            }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ApiService.prototype.get = function (endpoint) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request(endpoint, { method: 'GET', headers: this.getAuthHeaders() })];
            });
        });
    };
    ApiService.prototype.post = function (endpoint, body) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request(endpoint, {
                        method: 'POST',
                        headers: this.getAuthHeaders(),
                        body: JSON.stringify(body),
                    })];
            });
        });
    };
    ApiService.prototype.put = function (endpoint, body) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request(endpoint, {
                        method: 'PUT',
                        headers: this.getAuthHeaders(),
                        body: JSON.stringify(body),
                    })];
            });
        });
    };
    ApiService.prototype.delete = function (endpoint) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request(endpoint, { method: 'DELETE', headers: this.getAuthHeaders() })];
            });
        });
    };
    // Auth rides on the HttpOnly cookie (F-16). Don't set Content-Type on
    // FormData — let the browser add the multipart boundary.
    ApiService.prototype.uploadFile = function (endpoint, formData) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request(endpoint, { method: 'POST', body: formData })];
            });
        });
    };
    ApiService.prototype.putFile = function (endpoint, formData) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request(endpoint, { method: 'PUT', body: formData })];
            });
        });
    };
    return ApiService;
}());
export var apiService = new ApiService();
